import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import { courseList } from "../../api/Courses";
import usePrivateLink from "../config/usePrivateLink";
import Master from "./Master";
import { StaffList } from "../../api/Staff";
import { Link } from "react-router-dom";
import { handleFollowupsDownload } from "../enquiry/components/Master";
import EnquiryFollowupTable from "../enquiry/components/EnquiryFollowupTable";
import FeesFollowupTable from "./FeesFollowupTable";

export default function FeeFollowupV2() {
    const [loading, setLoading] = useState("");
    const hasAccess = usePrivateLink();
    const [courses, setCourses] = useState([]);
    const [sessions, setSessions] = useState([]);
    const [staffs, setStaffs] = useState([]);
    const [filters, setFilters] = useState({
        page: 1,
        type: "fees",
    });

    useEffect(() => {
        const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
        setSessions(parseSessions);
    }, []);

    useEffect(() => {
        const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
        setFilters((prev) => {
            if (prev.session_id || !activeSession) return prev;
            return {
                ...prev,
                session_id: activeSession,
            };
        });
    }, [sessions]);

    const getCourse = async () => {
        setLoading(true);
        try {
            const response = await courseList();
            if (response.data.status) {
                setCourses(response.data.data);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.message,
            );
        } finally {
            setLoading(false);
        }
    };

    const getStaffList = async () => {
        setLoading(true);
        try {
            const response = await StaffList(`limit=all&status=1`);
            if (response.data.status) {
                setStaffs(response.data.data);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.message,
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getCourse();
        getStaffList();
    }, []);

    return (
        <>
            {loading && <LoadingDiv />}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid p-4">
                                <div className="row">
                                    <Master />
                                    <div className="col-12">
                                        <div className="card p-3 mb-3 shadow-sm border-0">
                                            <div className="d-flex justify-content-between align-items-center">
                                                {/* LEFT SIDE */}
                                                <div className="d-flex align-items-center gap-3">
                                                    <div
                                                        className="d-flex align-items-center justify-content-center"
                                                        style={{
                                                            width: 45,
                                                            height: 45,
                                                            borderRadius: "12px",
                                                            background:
                                                                "linear-gradient(45deg,#185fa5,#4f8cff)",
                                                            color: "#fff",
                                                        }}
                                                    >
                                                        <i className="ri-customer-service-2-line fs-5"></i>
                                                    </div>

                                                    <div>
                                                        <h5 className="m-0 fw-bold text-dark">
                                                            Fees Follow-Ups List
                                                        </h5>
                                                        <small className="text-muted">
                                                            Manage and track all follow-up activities
                                                        </small>
                                                    </div>
                                                </div>

                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="d-flex flex-wrap gap-2 mb-3">
                                                        {/* SEARCH */}
                                                        {filters.search && (
                                                            <span className="badge bg-dark-subtle text-dark px-3 py-2">
                                                                Search: {filters.search}
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, search: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}

                                                        {/* SESSION */}
                                                        {filters.session_id && (
                                                            <span className="badge bg-primary-subtle text-primary px-3 py-2">
                                                                Session:{" "}
                                                                {sessions.find(
                                                                    (s) => s.id == filters.session_id,
                                                                )?.session || "All"}
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, session_id: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}

                                                        {/* COURSE */}
                                                        {filters.course_id && (
                                                            <span className="badge bg-success-subtle text-success px-3 py-2">
                                                                Course:{" "}
                                                                {
                                                                    courses.find((c) => c.id == filters.course_id)
                                                                        ?.title
                                                                }
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, course_id: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}

                                                        {/* COUNSELOR */}
                                                        {filters.counselor_id && (
                                                            <span className="badge bg-warning-subtle text-dark px-3 py-2">
                                                                Counselor:{" "}
                                                                {
                                                                    staffs.find(
                                                                        (s) => s.id == filters.counselor_id,
                                                                    )?.name
                                                                }
                                                                <i
                                                                    className="ri-close-line ms-2 cursor-pointer"
                                                                    onClick={() =>
                                                                        setFilters({ ...filters, counselor_id: "" })
                                                                    }
                                                                ></i>
                                                            </span>
                                                        )}
                                                    </div>

                                                    <button
                                                        title="Open Filters"
                                                        className="btn btn-light border rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                        data-bs-toggle="offcanvas"
                                                        data-bs-target="#filterCanvas"
                                                        style={{ width: 40, height: 40 }}
                                                    >
                                                        <i className="ri-filter-3-line text-primary"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card my-4">
                                            <div className="card-body" id="EnquiryData">
                                                <FeesFollowupTable
                                                    filters={filters}
                                                    setFilters={setFilters}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="offcanvas offcanvas-end" tabIndex="-1" id="filterCanvas">
                {/* HEADER */}
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title">Filters</h5>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                    ></button>
                </div>

                {/* BODY */}
                <div className="offcanvas-body">
                    <div className="row g-3 align-items-center">
                        {/* SEARCH */}
                        <div className="col-12">
                            <div className="form-floating form-floating-outline">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by Name, Mobile"
                                    value={filters?.search}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            search: e.target.value.toUpperCase(),
                                        })
                                    }
                                />
                                <label>Search by Name, Mobile</label>
                            </div>
                        </div>

                        {/* SESSION */}
                        <div className="col-sm-12">
                            <div className="form-floating form-floating-outline">
                                <select
                                    className="form-select"
                                    value={filters?.session_id}
                                    onChange={(e) =>
                                        setFilters({ ...filters, session_id: e.target.value })
                                    }
                                >
                                    <option value="all">All</option>
                                    {sessions?.map((s) => (
                                        <option key={s.id} value={s.id}>
                                            {s.session} : {s.status === "1" ? "Active" : "Inactive"}
                                        </option>
                                    ))}
                                </select>
                                <label>Session</label>
                            </div>
                        </div>

                        {/* COUNSELOR */}
                        <div className="col-12">
                            <div className="form-floating form-floating-outline">
                                <select
                                    className="form-select"
                                    value={filters?.counselor_id}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            counselor_id: e.target.value,
                                        })
                                    }
                                >
                                    <option value="">All</option>
                                    {staffs?.map((item) => (
                                        <option key={item?.id} value={item?.id}>
                                            {item?.name}
                                        </option>
                                    ))}
                                </select>
                                <label>Select Counselor</label>
                            </div>
                        </div>

                        {/* COURSE */}
                        <div className="col-12">
                            <div className="form-floating form-floating-outline">
                                <select
                                    className="form-select"
                                    value={filters?.course_id}
                                    onChange={(e) =>
                                        setFilters({
                                            ...filters,
                                            course_id: e.target.value,
                                        })
                                    }
                                >
                                    <option value="">All</option>
                                    {courses?.map((course, index) => (
                                        <option key={index} value={course.id}>
                                            {course.title}
                                        </option>
                                    ))}
                                </select>
                                <label>Course</label>
                            </div>
                        </div>

                        {/* BUTTONS */}
                        <div className="row g-2 mt-3">
                            <div className="col-6">
                                <button
                                    className="btn btn-primary w-100"
                                    data-bs-dismiss="offcanvas"
                                >
                                    Apply
                                </button>
                            </div>

                            <div className="col-6">
                                <button
                                    className="btn btn-outline-danger w-100"
                                    onClick={() =>
                                        setFilters({
                                            search: "",
                                            course_id: "",
                                            counselor_id: "",
                                            session_id: "",
                                        })
                                    }
                                >
                                    Reset
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
